module.exports = __webpack_public_path__ + "/images/logo-ico-bg-cercles.a46230b.png";